interface AlertProps {
  type: 'success' | 'error' | 'warning' | 'info'
  message: string
  onClose?: () => void
}

const styles = {
  success: 'bg-green-50 border-green-200 text-green-800',
  error: 'bg-red-50 border-red-200 text-red-800',
  warning: 'bg-yellow-50 border-yellow-200 text-yellow-800',
  info: 'bg-compumaq-dourado/15 border-compumaq-dourado/40 text-compumaq-doradoClaro',
}

export function Alert({ type, message, onClose }: AlertProps) {
  return (
    <div className={`flex items-center justify-between px-4 py-3 rounded-lg border text-sm ${styles[type]}`}>
      <span>{message}</span>
      {onClose && (
        <button onClick={onClose} className="ml-4 opacity-60 hover:opacity-100">
          ✕
        </button>
      )}
    </div>
  )
}
